<div class="container mt-3 d-flex gap-2">
  <div class="container card shadow-sm p-3 w-75">
      @if( isSubmitting()){
      <div class="position-absolute top-50 start-50 translate-middle" >
        <mat-spinner  color="accent"></mat-spinner>
      </div>
      }
    <h3>{{ title }}</h3>
    <form [formGroup]="techForm" (submit)="submit()">
      <div class="form-group">
        <label for="name">Name</label><br />
        <input
          type="text"
          id="name"
          name="name"
          class="form-control"
          formControlName="name"
          (input)="onNameChange()"
          required
        />
        <app-form-error [control]="techForm.controls['name']" [serverErrors]="serverErrors" fieldName="name"></app-form-error>
        <label for="slug">Slug</label><br />
        <input
          type="text"
          id="slug"
          name="slug"
          class="form-control"
          formControlName="slug"
          required
        />
        <app-form-error [control]="techForm.controls['slug']" [serverErrors]="serverErrors" fieldName="slug"></app-form-error>
        <label for="url">URL</label><br />
        <input type="text" id="url" name="url" class="form-control" formControlName="url" />
        <app-form-error [control]="techForm.controls['url']" [serverErrors]="serverErrors" fieldName="name"></app-form-error>

        <label for="description">Description</label><br />
        <textarea
          type="text"
          id="description"
          name="description"
          class="form-control"
          formControlName="description"
          rows="7"
        >
        </textarea>
        <app-form-error [control]="techForm.controls['description']" [serverErrors]="serverErrors" fieldName="description"></app-form-error>

        <label for="imageUrl">Image</label><br />
        <div class="d-flex gap-1">
          <button
            type="button"
            class="btn btn-primary btn-sm d-flex align-items-center gap-1"
            (click)="uploadImage()"
          >
            <span class="bi bi-cloud-upload"></span>
            Upload
          </button>
          <textarea
            type="text"
            id="imageUrl"
            name="imageUrl"
            class="form-control"
            formControlName="imageUrl"
            rows="1"
          >
          </textarea>
        </div>
        <app-form-error [control]="techForm.controls['imageUrl']" [serverErrors]="serverErrors" fieldName="imageUrl"></app-form-error>

        <label for="tags" class="me-2">Tags</label>
         <div class="d-flex w-100 flex-wrap gap-1 mb-1">
          @for (selectedTag of techForm.get('tags')?.value; track selectedTag) {
          <app-tag
            name="x {{selectedTag.name}}"
            [backgroundColor]="selectedTag.tagGenre?.backgroundColor!"
            [textColor]="selectedTag.tagGenre?.textColor!"
            (click)="removeSelectedTag(selectedTag?.id ?? '')">
          >
          </app-tag>
          }
        </div>

        <select id="tags" class="form-select" name="tags" #id (change)="selectTag(id.value)">
          <option value="-1">Select a tag</option>
          @for (tag of allTags; track tag) {
          <option [value]="tag.id">{{ tag.name }}</option>
          }
        </select>

        <label for="ecosystem">Ecosystem</label><br />
        <select
          class="form-select"
          name="ecosystem"
          formControlName="ecosystem"
          aria-label="Select ecosystem"
        >
          @for (ecosystem of ecosystems; track ecosystem) {
          <option [value]="ecosystem.id">
            {{ ecosystem.name }}
          </option>
          }
        </select>
        <br />

        <div class="w-100">
          <button
            class="btn btn-outline-primary mx-1 btn-sm"
            type="submit"
            [disabled]="techForm.invalid || isSubmitting()"
          >
            <span class="bi bi-save"></span>
            Save
          </button>
          <button
            class="btn btn-outline-secondary btn-sm"
            type="button"
            (click)="back()"
            [disabled]="techForm.invalid "
          >
            Cancel
          </button>
        </div>
      </div>
    </form>
  </div>
  <div class="w-25">
    <app-similar-techs [id]="techForm.get('id')?.value" [name]="techForm.get('name')?.value"></app-similar-techs>
  </div>
</div>
